module.exports = __webpack_public_path__ + "img/jyoti.274a77b4.png";